let state = {
  idFormatoCuestionario: 0,
  idPregunta: 0
}

let mutations = {

}

let actions = {

}

const SISEVA = {
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default SISEVA;



// WEBPACK FOOTER //
// ./src/store/SISEVA.js